import { StaticVideo } from '@/types/video.types';
import { Get } from '../helpers';

export const GetVideo = (channel: number, uuid: string): Promise<StaticVideo> => {
  return Get({
    path: `/v4/videos/channel/${channel}/videos/${uuid}`,
  });
};
